import { coordEach } from '@turf/turf'
import { Feature, Polygon, Position } from 'geojson'

// Single source of truth for how a polygon's vertices flatten into a list:
// rings in order, each ring's repeated closing coordinate dropped (turf's
// `excludeWrapCoord`). PolygonEastingNorthingList numbering, the map's
// nearest-vertex hover and the draw modal's coord_path mapping all rely on
// this order agreeing. Assumes spec-compliant closed rings.
//
// Twin: mobile has its own copy in
// mobile/app/components/atomic/elements/geolocation/utilities/polygonVertices.ts

export const getPolygonVertices = (
  polygon: Feature<Polygon> | Polygon,
): Position[] => {
  const vertices: Position[] = []

  coordEach(
    polygon,
    (coord) => {
      vertices.push(coord)
    },
    true,
  )

  return vertices
}

/**
 * Maps a (ringIndex, vertexIndexInRing) pair — e.g. a mapbox-gl-draw
 * `coord_path` like "0.2" — to the vertex's position in the flattened list
 * produced by getPolygonVertices. Returns null when out of range.
 */
export const getFlatVertexIndex = (
  polygon: Feature<Polygon> | Polygon,
  ringIndex: number,
  vertexIndexInRing: number,
): number | null => {
  let flatIndex = 0
  let indexInRing = 0
  let currentRing = -1
  let result: number | null = null

  coordEach(
    polygon,
    (_coord, _coordIndex, _featureIndex, _multiFeatureIndex, geometryIndex) => {
      if (geometryIndex !== currentRing) {
        currentRing = geometryIndex
        indexInRing = 0
      }

      if (
        result === null &&
        currentRing === ringIndex &&
        indexInRing === vertexIndexInRing
      ) {
        result = flatIndex
      }

      indexInRing += 1
      flatIndex += 1
    },
    true,
  )

  return result
}
